// extracted by mini-css-extract-plugin
export default {"wrapper":"InfoBox_wrapper__w8mjk","errorList":"InfoBox_errorList__DUHZM"};